import { render, staticRenderFns } from "./AuditTrailButton.vue?vue&type=template&id=fb177d7a"
import script from "./AuditTrailButton.vue?vue&type=script&lang=js"
export * from "./AuditTrailButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports